/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TipoEmpleoDescripcionDesarrolladorWebGet$Params {
}

export function tipoEmpleoDescripcionDesarrolladorWebGet(http: HttpClient, rootUrl: string, params?: TipoEmpleoDescripcionDesarrolladorWebGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, tipoEmpleoDescripcionDesarrolladorWebGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

tipoEmpleoDescripcionDesarrolladorWebGet.PATH = '/tipo-empleo/descripcion/Desarrollador_web';
